import auth from '../../../services/auth'
import sales from '../../../services/sales'
import * as _ from 'lodash'
import { cents } from '../../../filters/number'
import btnRechargeValue from './btn-recharge-value.vue'
import axios from 'axios';
import validaRecarga from '../../../validators/valor-recarga-valido'
import C from '../../common/constantes'
import vehicles from '../../../services/vehicles'


export default {
  data() {
    return {
      user: auth.currentUser,
      rechargeValue: undefined,
      rate: undefined,
      loadingRates: Promise.resolve(true),
      loading: Promise.resolve(true),
      source: undefined,
      rechargeUnit: undefined,
      unit: undefined,
      numeroDeVeiculos: undefined,
      valoresRoadCard: [],
      menorValorDeRecarga: undefined,
      errorMessage: ""

    }
  },
  computed: {
    contractId: function () {
      return this.$route.params.contractId;
    },
    planId: function(){
     return this.$route.params.planId;
    },
    valueFormatted: function () {
      this.$nextTick(()=>{
        $('#valueTotal').val($('#valueTotal').val());
      });
      return cents(this.rechargeValue).replace('R$', '');

    },
    total: function () {
      if (this.rate)
        return cents(this.rate.valueTotal + this.rate.taxTotal);
      else
        return cents(0);
    },
    tax: function () {
      if (this.rate)
        return cents(this.rate.taxTotal);
      else
        return cents(0);
    }
  },
  created() {
    this.menorValorDeRecarga = undefined;
    this.source = axios.CancelToken.source();

    if([C.PLAN_MAN_ECONOMICO,C.PLAN_AUT_ECONOMICO].includes(this.planId)){
      this.unit = C.RECHARGE_UNIT_ECONOMICO;
    }else if(this.planId == C.PLAN_AUT_PJ || this.planId == C.PLAN_MAN_PJ || this.planId == C.PLAN_PRE_SEM_TAXA){
        this.unit = C.RECHARGE_UNIT_PJ;
      } else {
        this.unit = C.RECHARGE_UNIT;
      }
  },
  mounted() {

    vehicles.getVehicleByContractIdContagem(this.contractId).then(res => {
   this.numeroDeVeiculos = res.length;

    })
  },
  methods: {

    incrementTotal: function (val) {
      val = parseInt(val);
      let total = parseInt(this.rechargeValue);
      if (this.rechargeValue)
        this.rechargeValue = total + val;
      else
        this.rechargeValue = val;

      this.calculateRecharge();
      this.$nextTick(function () {
          this.$validator.validateAll();
      })
    },
    setTotal: function (newValue) {

      this.rechargeValue = parseInt(newValue.replace(/[^0-9]/g, ''));

      this.calculateRecharge();
    },
    getQuantity: function () {
      if (!this.rechargeValue)
        return 0;

      let val = this.rechargeValue;
      val = parseInt(val);
      return val / this.unit;
    },
    calculateRecharge: function () {
      this.errorMessage = "";
      if (!validaRecarga.validate(this.rechargeValue, [this.unit])) {
        this.rate = undefined;
        return false;
      }
      this.source.cancel('cancelada');
      this.source = axios.CancelToken.source();
      this.waiting = true;

      if(this.planId == 70 || this.planId == 71){
        if(this.rechargeValue >= this.menorValorDeRecarga){
          this.errorMessage = "";
          let p = sales.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId:  this.planId, contractId: this.contractId})
          .then(resp => {
            this.rate = resp
            this.waiting = false;
          }).catch(err => {
            this.waiting = false;
            this.rate = undefined;
          });
          this.$store.dispatch('loading', p);
        }else{
          this.errorMessage = "Valor informado é menor que o mínimo esperado."
        }
      }else{
        this.errorMessage = "";
        let p = sales.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId:  this.planId, contractId: this.contractId})
        .then(resp => {
          this.rate = resp
          this.waiting = false;
        }).catch(err => {
          this.waiting = false;
          this.rate = undefined;
        });
        this.$store.dispatch('loading', p);
      }

    },
    valoresRecebidos(valoresRecebidos) {
      this.valoresRoadCard.push(valoresRecebidos);

      if(this.valoresRoadCard.length === 4){
        const menorValor = Math.min(...this.valoresRoadCard);
        this.menorValorDeRecarga = menorValor;

      }
    },
    getSalesOrder() {
      let salesOrder = {
        account: {moveMaisId: this.moveMaisId},
        type: "RECHARGE",
        salesType: "RECHARGE",
        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        contract: this.contractId,
        price: this.rechargeValue + this.rate.taxTotal,
        value: this.rechargeValue,
        products: [
          {
            productId: 2,
            productName: "RECARGA",
            quantity: 1,
            valueTotal: this.rechargeValue,
            valueUnit: this.rechargeValue
          },
          {
            productId: 3,
            productName: "TAXA DE RECARGA",
            quantity: 1,
            valueTotal: this.rate.taxTotal,
            valueUnit: this.rate.taxTotal
          }
        ]
      };

      return Promise.resolve(salesOrder);

    }

  },

  components: {
    btnRechargeValue
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/recharge/recharge-multiple.js